const PREFIX = 'REPORTS';

export const GET_GRAPH_REPORTS = `${PREFIX}/GET_GRAPH`;
export const GET_ME_REPORTS = `${PREFIX}/GET_ME`;
export const GET_SUB_REPORTS = `${PREFIX}/GET_SUB`;
export const SET_PERIOD_REPORT = `${PREFIX}/SET_PERIOD`;
